

import { classesRuntime, statesRuntime } from "./../../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_109_2_LayoutBlocksHeader";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_109_2_LayoutBlocksHeader__root","innerContent":"wds_1_109_2_LayoutBlocksHeader__innerContent","title":"wds_1_109_2_LayoutBlocksHeader__title","subtitle":"wds_1_109_2_LayoutBlocksHeader__subtitle"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




